import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DteTestProgress } from "../../../types/dte/testProgress";

interface State {
  progress: DteTestProgress | null;
  completed: boolean | null; 
  loading: boolean;
  error: string | null;
}

const initialState: State = {
  progress: null,
  completed: null,
  loading: false,
  error: null,
};

export const testProgressSlice = createSlice({
  name: "testProgress",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    setProgress: (state, action: PayloadAction<DteTestProgress>) => {
      state.progress = action.payload;
      state.error = null;
    },

    setCompleted: (state, action: PayloadAction<boolean>) => {
      state.completed = action.payload;
    },

    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },

    resetProgressState: (state) => {
      state.progress = null;
      state.completed = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setProgress,
  setCompleted, 
  setError,
  resetProgressState,
} = testProgressSlice.actions;

export default testProgressSlice.reducer;
